// extracted by mini-css-extract-plugin
export default {"editBtn":"CoveragePreferences_editBtn__MbuAW","coveragePrefHead":"CoveragePreferences_coveragePrefHead__UtXlW"};